<template>
    <div :data-tooltip='text_tooltip' class="tooltip-icon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_323_1579)">
                <path
                    d="M8 7.2C7.78783 7.2 7.58435 7.28429 7.43432 7.43431C7.28429 7.58434 7.2 7.78783 7.2 8V11.2C7.2 11.4122 7.28429 11.6157 7.43432 11.7657C7.58435 11.9157 7.78783 12 8 12C8.21218 12 8.41566 11.9157 8.56569 11.7657C8.71572 11.6157 8.8 11.4122 8.8 11.2V8C8.8 7.78783 8.71572 7.58434 8.56569 7.43431C8.41566 7.28429 8.21218 7.2 8 7.2ZM8.304 4.064C8.10923 3.98399 7.89077 3.98399 7.696 4.064C7.5978 4.10208 7.50809 4.15917 7.432 4.232C7.36134 4.30976 7.30452 4.39905 7.264 4.496C7.21922 4.59094 7.1973 4.69506 7.2 4.8C7.1994 4.90528 7.21958 5.00965 7.25939 5.10712C7.2992 5.20459 7.35786 5.29325 7.432 5.368C7.50976 5.43866 7.59906 5.49549 7.696 5.536C7.8172 5.58579 7.94878 5.60505 8.07916 5.59209C8.20955 5.57913 8.33475 5.53434 8.44377 5.46166C8.5528 5.38897 8.6423 5.29063 8.70441 5.17526C8.76653 5.05989 8.79935 4.93103 8.8 4.8C8.79706 4.58819 8.71419 4.38531 8.568 4.232C8.49192 4.15917 8.40221 4.10208 8.304 4.064ZM8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 6.94942 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0ZM8 14.4C6.7342 14.4 5.49683 14.0246 4.44435 13.3214C3.39188 12.6182 2.57158 11.6186 2.08717 10.4492C1.60277 9.27973 1.47603 7.9929 1.72298 6.75142C1.96992 5.50994 2.57946 4.36957 3.47452 3.47452C4.36958 2.57946 5.50995 1.96992 6.75143 1.72297C7.9929 1.47603 9.27973 1.60277 10.4492 2.08717C11.6186 2.57157 12.6182 3.39188 13.3214 4.44435C14.0246 5.49682 14.4 6.7342 14.4 8C14.4 9.69738 13.7257 11.3253 12.5255 12.5255C11.3253 13.7257 9.69739 14.4 8 14.4Z"
                    fill="#7B7D93" />
            </g>
            <defs>
                <clipPath id="clip0_323_1579">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>
<script>
export default ( {
    props: ["text_tooltip"]
} )
</script>

<style lang="sass">
[data-tooltip]
    position: relative

[data-tooltip]::before 
    content: attr(data-tooltip)
    position: absolute
    width: 360px
    left: -10px
    bottom: 35px
    background: #F7F7F9
    color: #000000
    padding: 10px
    pointer-events: none
    opacity: 0
    transition: 0.3s ease-in-out
[data-tooltip]:hover::after
    content: " "
    position: absolute
    bottom: 110%
    left: 50%
    margin-left: -5px
    width: 12px
    height: 12px
    border-top: 10px solid #F7F7F9
    border-right: 6px solid transparent
    border-left: 6px solid transparent
    font-size: 0
    line-height: 0


[data-tooltip]:hover::before 
    opacity: 1
    bottom: 35px

</style>
